import { Composition } from '@texas/api/endpoints/compositionApi';
import { Material } from '@texas/api/endpoints/metadata/materialsApi';
import { metricShortName } from '@texas/components/shared/composition/dimension/translations';

export function extractCombinedMaterial(
  materials: Material[],
  combinedMaterials: number[],
) {
  if (combinedMaterials.length === 0) {
    return null;
  } else if (combinedMaterials.length === 1) {
    return materials.find((x) => x.id === combinedMaterials[0]) ?? null;
  }

  const foundMaterial = materials
    .filter((m) => m.combinationOf.length > 0)
    .find((d) =>
      d.combinationOf.every((c) => combinedMaterials.some((s) => s === c.id)),
    );

  return foundMaterial ?? null;
}

export function extractDimensionSize(
  compositions: Composition[],
  maxLength: number,
): string | null {
  if (compositions.length === 0) return null;

  const dimensionParts: string[] = [];
  const metricsUsed = new Set<number>();

  for (const composition of compositions) {
    const dimensions = composition.dimensionGroup?.dimensions ?? [];
    if (dimensions.length === 0) continue;

    const values = dimensions.map((d) => {
      metricsUsed.add(d.metric);
      return d.value;
    });

    dimensionParts.push(values.join('x'));
  }

  if (dimensionParts.length === 0) return null;

  const metrics = Array.from(metricsUsed)
    .map((m) => metricShortName(m))
    .join(' ');
  const result = `${dimensionParts.join(' ')} ${metrics}`;

  if (result.length > maxLength) {
    return null;
  }

  return result;
}
